import React from 'react';
import { ArrowRight, Clock } from 'lucide-react';
export const CTA = () => {
  return <section id="cta" className="w-full py-16 bg-gray-100 text-gray-800" data-id="element-10">
      <div className="container mx-auto px-4 md:px-8" data-id="element-11">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center text-gray-900" data-id="element-12">
          Act Before Tonight
        </h2>
        <div className="max-w-2xl mx-auto bg-white p-8 rounded-lg shadow-md mb-8" data-id="element-13">
          <div className="flex items-start gap-4 mb-4" data-id="element-14">
            <Clock className="w-8 h-8 flex-shrink-0 mt-1 text-gray-700" data-id="element-15" />
            <p className="text-xl text-gray-800" data-id="element-16">
              I don't know how long they'll have{' '}
              <span className="font-bold" data-id="element-17">stock</span>.
            </p>
          </div>
          <p className="text-xl mb-4 text-gray-800" data-id="element-18">
            Because every time people discover this, it{' '}
            <span className="font-bold" data-id="element-19">sells out quickly</span>.
          </p>
          <p className="text-xl mb-4 text-gray-800" data-id="element-20">
            So tonight, when <span className="font-bold" data-id="element-21">2:37 AM</span> rolls
            around…
          </p>
          <p className="text-xl font-bold text-gray-900" data-id="element-22">
            You won't be pacing the kitchen.
          </p>
          <p className="text-xl font-bold text-gray-900" data-id="element-23">You'll be sleeping.</p>
        </div>
        <div className="flex justify-center" data-id="element-24">
          <a href="https://www.vitalrelief.co.uk/products/vital-relief™-sleep-through-the-night-knee-sleeve" className="inline-flex items-center bg-gray-900 hover:bg-black text-white font-bold py-4 px-8 rounded-lg text-2xl transition duration-300 shadow-lg" data-id="element-25">
            <span className="mr-2" data-id="element-26">Check Availability</span>
            <ArrowRight className="w-6 h-6" data-id="element-27" />
          </a>
        </div>
        <p className="text-center mt-6 text-lg text-gray-600" data-id="element-28">
          <span className="font-bold" data-id="element-29">
            Limited stock available. 60-day money-back guarantee.
          </span>
        </p>
      </div>
    </section>;
};